import { useEffect } from "react";
import { Outlet, UIMatch, useMatches } from "react-router-dom";
import { GoftinoProvider } from "@/utils/goftino";
import { RouteType } from "./constant";
import { useImmerAtom } from "jotai-immer";
import { coreAtom } from "@/core/state/root";
import { useGlobalEventGoftino } from "@/core/lib/goftino";

const InitRoot = () => {
  const matches = useMatches() as UIMatch<unknown, RouteType["meta"]>[];
  const [, setCoreState] = useImmerAtom(coreAtom);
  useGlobalEventGoftino();

  useEffect(() => {
    const last = matches.pop();
    if (last?.handle?.isPage === true) {
      setCoreState((draft) => {
        draft.lastVisitedUrlThatWasAPage = last.pathname;
      });
    }
  }, [matches]);

  return (
    <GoftinoProvider chatId="G9nFLf">
      <Outlet />
    </GoftinoProvider>
  );
};

export default InitRoot;
